export const DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_ERROR =
  'docFlowSendingEpostSettingsErrorNotification'

export const DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_SUCCESS =
  'docFlowSendingEpostSettingsSuccessNotification'

export const DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_INFO =
  'docFlowSendingEpostSettingsInfoNotification'

export const DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_COST_IS_OUTDATED =
  'docFlowSendingEpostSettingsCostIsOutdatedNotification'

export const DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_UNAVAILABLE =
  'docFlowSendingEpostSettingsUnavailableNotification'

export const DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_NO_CALCULATION =
  'docFlowSendingEpostSettingsNoCalcultionNotification'

export const DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_NOT_ENOUGH_CREDITS =
  'docFlowSendingEpostSettingsNoEnoughCreditsNotification'

export const DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_VALID_INFO =
  'docFlowSendingEpostSettingsValidInfonNotification'

export const DOC_FLOW_SENDING_EPOST_SETTINGS_NOTIFICATION_ID_VALIDATION_ERRORS =
  'docFlowSendingEpostSettingsValidationErrorsNotification'
